import { GretaAIChatFinanceAccess } from '../../GretaAIChat.constants'

export const GRETA_AI_CHAT_FINANCE_ACCESS_DEFAULT = {
  access: GretaAIChatFinanceAccess.NoAccess,
  isPreviewSeen: false,
  isRevoked: false,
  isStale: false,
  isUsed: false,
  revocation: 0,
}
